(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('brand', {
                parent: 'admin',
                abstract: true,
                data: {
                    authorities: [],
                    pageTitle: 'category.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/flyers/brand-flyer/brand-flyer.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('categorys');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('brand');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            }).state('brands-list', {
                parent: 'brand',
                url: '/brands-list',
                data: {
                    pageTitle: 'categorys.title',
                    authorities: []
                },
                views: {
                    'brand-list': {
                        templateUrl: 'app/admin/flyers/brand-flyer/brand-flyer-list.html',
                        controller: 'BrandFlyerListController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
